import React from 'react'
import Header from '../Header'
import axios from 'axios';
export default function Contact() {
  // const baseURL = "http://localhost:3001/api/web_data";
  const baseURL = "https://legal.ptinfos.com/api/web_data";
  const [post, setPost] = React.useState(null);
  React.useEffect(() => {
    axios.get(baseURL).then((response) => {
      setPost(response.data);
    });
  }, []);

  if (!post) return null;
  return (
    <>
      <Header/>
      <div className='container'>
        <div className="row my-3">
          <div className="col-sm-12">
            <h1 className='text-center'>Contact Us</h1>
            <div className="row">
              <div className="col-sm-8">
                <h3>Send us an email</h3>
              </div>
              <div className="col-sm-4">
                <h3>Contact Information</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}